export default __webpack_public_path__ + "static/media/hideIcon.c55b0f01.png";